import { api } from '@/scripts/api';
import { helpers } from '@/scripts/helpers';

export const filesTab = {
    state: () => ({
        files: [],
    }),

    mutations: {
        addFile(state, file) {
            state.files.push(file);
        },

        removeFile(state, fileToRemove) {
            const index = state.files.indexOf(fileToRemove);
            if (index !== -1) {
                state.files.splice(index, 1);
            }
        },

        setFiles(state, files) {
            state.files = files;
        },

    },

    actions: {
        loadFiles({ rootState, commit }) {
            const opportunityId = rootState.opportunity.id;
            api.get(`/service/Collaterals?DealId=${opportunityId}&$select=Id,Name,FileSizeInBytes,MimeType,Url`)
                .then((response) => {
                    const fileResponse = response.data.value;
                    const files = fileResponse.map((file) => ({
                        id: file.Id,
                        name: file.Name,
                        size: file.FileSizeInBytes,
                        type: file.MimeType,
                        downloadUrl: file.Url,
                    }));
                    commit('setFiles', files);
                })
                .catch((error) => {
                    helpers.showFailNotification(
                        'An error occurred while fetching the files. Please try again.',
                        { error },
                    );
                });
        },

        deleteFile({ rootState, commit }, file ) {
            commit('removeFile', file);
            const payload = {
                DealId: rootState.opportunity.id,
                CollateralId: file.id,
            };
            api
                .delete('/api/DealCollaterals', payload)
                .then(() => {
                })
                .catch((error) => {
                    helpers.showFailNotification(
                        'An error occurred while deleting your file. Please try again.',
                        { error },
                    );
                    commit('addFile', file);
                })
        },

        uploadFile({ rootState, commit, dispatch }, file) {
            commit('addFile', file);
            dispatch('uploadInCollaterals', file)
            .then(() => {
                const payload = {
                    DealId: rootState.opportunity.id,
                    CollateralId: file.fileId,
                };
                return api.post('/api/DealCollaterals', payload);
            })
            .catch((error) => {
                helpers.showFailNotification(
                    'An error occurred while uploading your file. Please try again.',
                    { error },
                );
                commit('removeFile', file);
            })
        },

        uploadFiles({ state, rootState, dispatch }) {
            for (const file of state.files) {
                dispatch('uploadInCollaterals', file)
                .then(() => {
                    const payload = {
                        DealId: rootState.opportunity.id,
                        CollateralId: file.fileId,
                    };
                    return api.post('/api/DealCollaterals', payload);
                })
                .catch((error) => {
                    helpers.showFailNotification(
                        'An error occurred while uploading your file. Please try again.',
                        { error },
                    );
                })
            }
        },

        uploadInCollaterals({ dispatch }, documentFile) {
            if (documentFile.fileId) {
                return new Promise((resolve) => resolve());
            }
            return new Promise((resolve, reject) => {
                dispatch('mediaImageRequest', { name: documentFile.name, file: documentFile.file })
                    .then((result) => {
                        documentFile.fileId = result.Id;
                        documentFile.id = result.Id;
                        documentFile.url = result.Url;
                        documentFile.downloadUrl = result.Url;
                        documentFile.name = result.Name;
                        documentFile.size = result.FileSizeInBytes;
                        documentFile.type = result.MimeType;
                        documentFile.iconUrl = helpers.getThumbnailUrlFromMimeType(
                            result.MimeType,
                        );

                        resolve();
                    })
                    .catch((error) => {
                        helpers.showFailNotification(
                            'An error occurred while uploading your file. Please try again.',
                            { error },
                        );
                        reject();
                    });
            });
        },

        mediaImageRequest(context, { name, file }) {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('file', file, name);
                formData.append('clientId', context.getters.clientId);
                api
                    .ajax({
                        url: '/api/Collaterals/File',
                        method: 'POST',
                        data: formData,
                        contentType: false,
                        processData: false,
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        helpers.showFailNotification(
                            'An error occurred while saving your attachment piece',
                            { error },
                        );
                        reject();
                    }); 
            });
        },
    }
};